import request from '../request';
import { EmailTemplateVariantAPI } from './urls';

// WI-443: Super-Admin customisable system email templates.

export const getOptions = () =>
  request({ url: EmailTemplateVariantAPI.getOptions, method: 'GET' });

export const getAllVariants = () =>
  request({ url: EmailTemplateVariantAPI.getAll, method: 'GET' });

export const getVariantsByKey = (templateKey) =>
  request({ url: EmailTemplateVariantAPI.getByKey(templateKey), method: 'GET' });

export const addVariant = (variant) =>
  request({ url: EmailTemplateVariantAPI.add, method: 'POST', data: variant });

export const updateVariant = (variant) =>
  request({ url: EmailTemplateVariantAPI.update, method: 'PUT', data: variant });

export const deleteVariant = (id) =>
  request({ url: EmailTemplateVariantAPI.delete(id), method: 'DELETE' });

export const cloneVariant = (id) =>
  request({ url: EmailTemplateVariantAPI.clone(id), method: 'POST' });

export const previewTemplate = (payload) =>
  request({ url: EmailTemplateVariantAPI.preview, method: 'POST', data: payload });

export const seedDefaults = () =>
  request({ url: EmailTemplateVariantAPI.seedDefaults, method: 'POST' });

const emailTemplateVariantService = {
  getOptions,
  getAllVariants,
  getVariantsByKey,
  addVariant,
  updateVariant,
  deleteVariant,
  cloneVariant,
  previewTemplate,
  seedDefaults,
};

export default emailTemplateVariantService;
